import { Outlet } from 'react-router-dom'

const FAQ = () => <Outlet />

export default FAQ
